var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myBanner",class:_vm.getClassList()},[(_vm.banner && _vm.$store.state.myRender.private.banner_isShow)?[(_vm.$store.state.full_screen_banner.isRender)?_c('full_screen_banner',{class:'page_' + _vm.$store.state.app.now_page,attrs:{"banner":_vm.banner}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cce42f18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/public/banner.vue
// module id = null
// module chunks = 